import { useEffect, useState } from 'react'
import style from './index.module.scss'
import FeedbackStar from '@/components/feedback_star'
import { fetchFeedbackGetList, fetchFeedbackSubmit } from '@/apis/feedback/feedback.api'
import type { SubjectInfoDTOList } from '@/apis/feedback/feedback.interface'
import { Button, FormControl, FormControlLabel, FormHelperText, OutlinedInput, Radio } from '@mui/material'
import {
  RadioLabelStyle,
  RadioColorStyle,
  SubjectFormStyle,
  SubjectInputStyle,
  DescTitleStyle,
  DescFormStyle,
  DescInputStyle,
  SubmitBTnStyle
} from './style'
import RedClose from "@/common-components-src/assets/icons/redClose.svg";
import UKToast from '@/components/UKToast'


interface PropsType {
  open: boolean //控制弹窗开关
  closeFn?: () => void //关闭回调
  score?: number //默认展示星级评分
  sourceType: number //反馈来源类型 枚举值 1-Me、2-Search、3-Recommend、4-Products
  k?: string | undefined; // 搜索关键字
}
const Feedback = ({ open, closeFn, score, sourceType, k }: PropsType) => {

  const textError = "This must include at least 10 characters.";
  const textMinCount = 10;//最少输入字数
  const maxSubjectCount = 100;//最大输入字数
  const maxCharacterCount = 500;//描述最大输入字数

  const [isOpen, setIsOpen] = useState(false)
  const [scoreNum, setScoreNum] = useState(score)
  const [subjectList, setSubjectList] = useState<SubjectInfoDTOList[]>([])
  const [selectedValue, setSelectedValue] = useState<string>(); // 默认选中
  const [selectedSubject, setSelectedSubject] = useState<string>(); // 默认选中
  const [subjectRadio, setSubjectRadio] = useState();// 需要反馈的问题类型
  const [subjectHelperTextError, setSubjectHelperTextError] = useState(""); // subject输入框错误提示
  const [subjectValue, setSubjectValue] = useState(""); // subject输入框的value值
  const [subjectCount, setSubjectCount] = useState(0);//subject输入框的文本个数
  const [descHelperTextError, setDescHelperTextError] = useState(""); // desc输入框错误提示
  const [desValue, setDesValue] = useState(""); // desc输入框的value值
  const [descCount, setDescCount] = useState(0);//desc输入框的文本个数
  const [isSubmitting, setIsSubmitting] = useState(false); // 正在提交中

  const getFeedbackList = async () => {
    const res = await fetchFeedbackGetList({ sourceType })
    const { code, data } = res
    if (code === '200') {
      setSubjectList(data?.subjectInfoDTOList || [])
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }

  const handlerClose = () => {
    setIsOpen(false);
    closeFn && closeFn()
  }

  const handleChange = (event: any, item: SubjectInfoDTOList) => {
    if (!item.showInputBox) {
      setSubjectValue('')
    }
    setSubjectHelperTextError("")
    setSelectedSubject(item.subject)
    setSelectedValue(event.target.value);
    setSubjectRadio(event.target.value);
  }

  const handleSubjectOnBlur = () => {
    setSubjectHelperTextError(subjectCount && subjectCount < textMinCount ? textError : "");
  };

  const handleDescOnBlur = () => {
    setDescHelperTextError(descCount && descCount < textMinCount ? textError : "");
  };
  //只上报评分
  const onStarSubmit = async () => {
    const params = {
      sourceType,
      starScore: scoreNum,
      platform: 3,
      extMap: { QUERY: k }
    }
    fetchFeedbackSubmit(params)
  }
  const closeStarHandler = (scoreNum: number) => {
    if (scoreNum) {
      onStarSubmit()
    }
    handlerClose()
  }

  // 提交反馈
  const OnSubmit = async () => {
    handleDescOnBlur()
    handleSubjectOnBlur()
    if (isSubmitting) {
      return
    }
    if (!!descHelperTextError || !!subjectHelperTextError) {
      return
    }

    let params = {
      sourceType,
      subjectType: subjectRadio,
      subject: subjectValue ? subjectValue : selectedSubject,
      feedbackDetails: desValue,
      platform: 3,
      appVersion: "",
      starScore: scoreNum,
      extMap: { QUERY: k }
    }

    setIsSubmitting(true);
    fetchFeedbackSubmit(params).then((res) => {
      if (res && res.success) {
        UKToast.show({
          icon: 'success',
          content: 'Thanks for your feedback',
        })
        handlerClose()
      } else {
        setIsSubmitting(false);
        UKToast.show({
          icon: 'fail',
          content: 'Oops! Something went wrong. Please try again',
        })
      }
    });
  };
  //点击star事件
  const clickStar = (scoreNum: number) => {
    setScoreNum(scoreNum)
  }

  useEffect(() => {
    let count = desValue ? desValue.length : 0
    setDescCount(count)
  }, [desValue])

  useEffect(() => {
    let count = subjectValue ? subjectValue.length : 0
    setSubjectCount(count)
  }, [subjectValue])

  useEffect(() => {
    if (open) {
      getFeedbackList()
    }
  }, [open])

  if (isOpen) {
    return (
      <div className={style.feedbackDialog}>
        <FeedbackStar
          onClose={closeStarHandler}
          scoreNum={scoreNum}
          onClickStar={clickStar}
          sourceType={sourceType}
          title="How about the results?"
        />
        <div className={style.form}>
          <div className={style.form_title}>{`Please let us know what you think about our ${sourceType === 3 ? 'recommendations' : 'search results.'}.`}</div>
          {
            subjectList && subjectList.length > 0 &&
            <div className={style.form__radio}>
              {
                subjectList.map((item: SubjectInfoDTOList, index: number) => {
                  return (
                    <div key={index}>
                      <FormControlLabel
                        sx={RadioLabelStyle}
                        value={String(item.subjectType)}
                        label={item.subject}
                        control={
                          <Radio
                            sx={RadioColorStyle}
                            checked={selectedValue === String(item.subjectType)}
                            onChange={(e) => handleChange(e, item)}
                            value={String(item.subjectType)}
                            name="radio-buttons"
                          />
                        }
                      />
                      {item.showInputBox && String(item.subjectType) === selectedValue && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          flexWrap: 'wrap' as const
                        }} className={style.input__wrap}>
                          <FormControl sx={SubjectFormStyle} id="outlined-subject" variant="outlined" error={!!subjectHelperTextError}>
                            <OutlinedInput
                              multiline
                              minRows={4}
                              maxRows={4}
                              type="text"
                              value={subjectValue}
                              style={SubjectInputStyle}
                              inputProps={{ maxLength: maxSubjectCount }}
                              placeholder={`Your feedback subject is important! Please enter a minimum of ${textMinCount} characters or more.`}
                              onChange={(event) => setSubjectValue(event.target.value)}
                              onBlur={handleSubjectOnBlur}
                            />
                            {!!subjectHelperTextError && (
                              <FormHelperText>
                                <span className={style.error_text}>
                                  <RedClose />
                                  {subjectHelperTextError}
                                </span>
                              </FormHelperText>
                            )}
                          </FormControl>
                          <span className={style.input_text}>
                            <span className={style.input_text_color}>{subjectCount}</span>
                            <span>/{maxSubjectCount}</span>
                          </span>
                        </div>
                      )}
                    </div>
                  )
                })
              }
            </div>
          }
          <div style={DescTitleStyle} className={style.form__title}>Your suggestions help us serve you better. Please share your thoughts below:</div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap' as const
          }} className={style.input__wrap}>
            <FormControl sx={DescFormStyle} id="outlined-basic" variant="outlined" fullWidth error={!!descHelperTextError}>
              <OutlinedInput
                multiline
                minRows={4}
                maxRows={4}
                type="text"
                value={desValue}
                style={DescInputStyle}
                inputProps={{ maxLength: maxCharacterCount }}
                placeholder={`Please enter your suggestions or questions.`}
                onChange={(event) => setDesValue(event.target.value)}
                onBlur={handleDescOnBlur}
              />
              {!!descHelperTextError && (
                <FormHelperText>
                  <span className={style.error_text}>
                    <RedClose />
                    {descHelperTextError}
                  </span>
                </FormHelperText>
              )}
            </FormControl>
            <span className={style.input_text}>
              <span className={style.input_text_color}>{descCount}</span>
              <span>/{maxCharacterCount}</span>
            </span>
          </div>

        </div>
        <Button
          sx={SubmitBTnStyle}
          onClick={OnSubmit}
          disableElevation
          disabled={!!descHelperTextError || !!subjectHelperTextError || selectedValue == "0" || !scoreNum}>
          Submit
        </Button>
      </div>
    )
  }

}

export default Feedback
